export const GETRELATORIOSAGA = "GETRELATORIOSAGA";
export const GETRELATORIO = "GETRELATORIO";
